module.exports = __webpack_public_path__ + "img/@team_img_02.51ee9f1d.jpg";